/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import { TYPE_COMPONENT_BY_TYPE_ACTE } from '@/constants';

import InformationsEnfant from '../StepActe/InformationsEnfant';

/**
 * Étape « Enfant » de l'acte de reconnaissance : `INFORMATIONS SUR L'ENFANT`
 * extraite de l'étape « Acte » (`StepActeReconnaissance`) dans sa propre
 * étape, affichée avant celle des parents.
 */
const StepEnfant = () => {
  const { data, onChange, errors, selectedTypeActe } =
    React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Enfant] ?? {};

  const typeComponent = selectedTypeActe
    ? TYPE_COMPONENT_BY_TYPE_ACTE[selectedTypeActe]
    : undefined;

  return (
    <div
      className="assistant-step-enfant"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsEnfant
        data={data}
        errors={errorsStep}
        onChange={onChange}
        showLieuNaissance={false}
        typeComponent={typeComponent}
      />
    </div>
  );
};

export default StepEnfant;
